import { basicEnum } from "./base";

export const GatewayProviderEnum = basicEnum([
    {
        label: "Xendit",
        value: "xendit",
    },
]);

export namespace GatewayProviderEnum {
    export type Labels = (typeof GatewayProviderEnum)["labels"][number];
    export type Values = (typeof GatewayProviderEnum)["values"][number];
}
